import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  project: [],
  allProject: [],
  addProjectData: []
};

export const ProjectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    getProjectAction: (state, action) => {
      state.project = action.payload;
    },
    getAllProjectAction: (state, action) => {
      // 
      state.allProject = action.payload;
    },
    getAddProjectDataAction: (state, action) => {
      // 
      state.addProjectData = action.payload;
    },

  },
});

export default ProjectSlice.reducer;

export const { getProjectAction, getAllProjectAction, getAddProjectDataAction } = ProjectSlice.actions;
